import { FC } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import './App.css';
import Layout from './Layout';
//import { useAuth } from 'react-oidc-context';
import { FluentProvider, webLightTheme } from '@fluentui/react-components';

//'http://beta.2yc3.org/'; //

interface AppProps {

}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 1000 * 60 * 60 * 24, // 24 hours
    },
  },
});

// const syncStoragePersister = createSyncStoragePersister({
//   storage: window.localStorage,
//   deserialize: (s) => JSON.parse(s, (k, v) => {
//     // if (k === 'timestamp') {
//     //   console.log(v);
//     // }
//     if (k === 'date' || k === 'time' || k === 'expiration') { //|| 
//       return new Date(Date.parse(v));
//     // } else if (k === 'timestamp' && typeof k === 'string' && v.includes('Z')){
//     //   console.log(v);
//     //   return new Date(Date.parse(v));
//     } else {
//       return v;
//     }
//   })
// })


const App: FC<AppProps> = () => {
  //const auth = useAuth();
  //console.log("import.meta.env");

//console.log(import.meta.env);
  return (
    <FluentProvider theme={webLightTheme}>
      <QueryClientProvider client={queryClient}>
      {/* <PersistQueryClientProvider client={queryClient} persistOptions={{ persister: syncStoragePersister }}> */}
        
        <Layout />
      {/* </PersistQueryClientProvider> */}
      </QueryClientProvider>
    </FluentProvider>
  );
}

export default App;
